import { IoIosInformationCircleOutline } from "react-icons/io";
import { IoRepeatOutline } from "react-icons/io5";
import { MdOutlineCallMade } from "react-icons/md";
import { LuArrowDownLeft } from "react-icons/lu";
import { Text, Tooltip } from "@chakra-ui/react";
import { TFunction } from "i18next";
import { TransactionType } from "../utils/types.global";

export const getTransactionsTypeIcon = (type: number, t: TFunction) => {
    switch (TransactionType[type]) {
        case "In":
            return <div className="flex flex-row justify-center items-center relative">
                <Tooltip label={t("IN")} placement='auto'>
                    <>
                        <LuArrowDownLeft color="green" width={20} height={20} />
                        <Text className="ml-2"> {t("IN")}</Text>
                    </>
                </Tooltip>
            </div>
        case "Out":
            return <div className="flex flex-row justify-center items-center relative">
                <Tooltip label={t("OUT")} placement='auto'>
                    <>
                        <MdOutlineCallMade color="red" width={20} height={20} />
                        <Text className="ml-2"> {t("OUT")}</Text>
                    </>
                </Tooltip>
            </div>
        case "InventoryTransfer":
            return <div className="flex flex-row justify-center items-center start relative">
                <Tooltip label={t("INVENTORY_TRANSFER")} placement='auto'>
                    <>
                        <IoRepeatOutline color="blue" width={20} height={20} />
                        <Text className="ml-2"> {t("INVENTORY_TRANSFER")}</Text>
                    </>
                </Tooltip>
            </div>
        default:
            return <div className="flex flex-row justify-center items-center start relative">
                <Tooltip label={t("UNKNOWN")} placement='auto'>
                    <>
                        <IoIosInformationCircleOutline color="orange" width={20} height={20} />
                        <Text className="ml-2"> {t("UNKNOWN")}</Text>
                    </>
                </Tooltip>
            </div>  
    }
}

